import { ScatterDataPoint } from 'chart.js'
import { getCssRgbValue } from 'shared/utils/get-css-rgb-value'

export const getChartconfig = ({
  labels,
  data,
  type,
}: {
  labels: string[]
  data: (number | ScatterDataPoint)[]
  type?: string
}) => {
  return {
    type,
    labels,
    datasets: [
      {
        data,
        backgroundColor: getCssRgbValue('--brand-primary', 0.05),
        borderColor: getCssRgbValue('--brand-primary', 0.15),
        pointBackgroundColor: getCssRgbValue('--brand-primary', 0.15),
        pointBorderColor: getCssRgbValue('--brand-primary', 0.15),
        fill: true,
      },
    ],
  }
}
